import React from "react";
import { graphql, useStaticQuery } from "gatsby";

import { useBreakpoint } from "hooks/useBreakpoint";
import { ConditionalSwiper } from "../../components/shared/conditionalSwiper";
import { Link } from "../../utils/customLink";
import Image from "../../components/image";

const TrustedPartners = ({ trustedPartnerList }) => {
  const breakpoint = useBreakpoint();

  const { genericPartnerDetails } = useStaticQuery(graphql`
    query {
      genericPartnerDetails: wp {
        conservationPartners: acfOptionsConservationPartners {
          pageTitle
          conservationPartners {
            trustedPartners {
              partnerTitle
              partnerUrl
              partnerStandardLogo {
                ...smallGalleryData
              }
              partnerHoverLogo {
                ...smallGalleryData
              }
            }
          }
        }
      }
    }
  `);

  const conservationPartnerList =
    trustedPartnerList?.conservationPartners?.conservationPartners
      ?.trustedPartners ??
    genericPartnerDetails?.conservationPartners?.conservationPartners
      ?.trustedPartners ??
    [];

  if (conservationPartnerList?.length < 1) {
    return <></>;
  }

  return (
    <>
      <section
        className="flex flex-col items-center justify-center px-4 py-8 mx-auto bg-white md:px-0 dark:bg-gray-darkest md:min-h-[600px] md:pt-0"
        style={{ gridArea: "1/1" }}
      >
        <div className="container flex flex-col items-center w-full md:w-9/12 md:gap-4">
          <h2 className="w-full py-8 font-alice text-[26px] sm:text-[38px] dark:font-body">
            Our trusted partners
          </h2>
          <div className="flex w-full sm:w-4/5">
            <div className="grid grid-cols-1 gap-8 md:grid-cols-6 ">
              <ConditionalSwiper
                condition={breakpoint === "xs"}
                slidesPerView={2.3}
                spaceBetween={24}
                centeredSlides={true}
                navigation={true}
                pagination={{
                  clickable: true
                }}
                autoplay={{
                  delay: 1000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true
                }}
                speed={1300}
                className="w-full h-full partners-swiper"
              >
                {conservationPartnerList &&
                  conservationPartnerList?.length &&
                  conservationPartnerList?.map((partner, i) => {
                    const partnerLogo =
                      partner?.partnerStandardLogo?.localFile &&
                      partner?.partnerStandardLogo?.localFile?.publicURL
                        ? partner.partnerStandardLogo?.localFile?.publicURL
                        : partner.partnerStandardLogo?.sourceUrl;

                    const partnerHoverLogo =
                      partner?.partnerHoverLogo?.localFile &&
                      partner?.partnerHoverLogo?.localFile?.publicURL
                        ? partner.partnerHoverLogo?.localFile?.publicURL
                        : partner.partnerHoverLogo?.sourceUrl;

                    const partnerTitle = partner?.partnerTitle;
                    const partnerUrl = partner?.partnerUrl;

                    return (
                      <div
                        className="flex items-center justify-center py-24 md:py-2 relative"
                        key={`partner-${i}`}
                      >
                        {partnerUrl && (
                          <Link
                            className="absolute top-0 right-0 bottom-0 left-0"
                            to={partnerUrl}
                            target={"_blank"}
                            rel="noreferrer"
                          />
                        )}
                        <div className="flex items-center justify-center">
                          <div className="icon">
                            <Image
                              imageAlt={partnerTitle}
                              image={""}
                              imageClass={`object-contain object-center w-30 h-30`}
                              sourceUrl={partnerLogo}
                              onMouseOver={(e) =>
                                (e.currentTarget.src =
                                  partnerUrl !== "#"
                                    ? partnerHoverLogo
                                    : partnerLogo)
                              }
                              onMouseOut={(e) =>
                                (e.currentTarget.src = partnerLogo)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </ConditionalSwiper>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TrustedPartners;
